import {
    /** FETCH ADDBASKET  */
    FETCH_ADDBASKET_FULFILLED,
    FETCH_ADDBASKET_REJECTED,
    FETCH_ADDBASKET_PENDING,
    RESET_ADDBASKET,
  } from "../../actions/payment/addBasket";
  const initialState = {
    done: false,
    error: false,
    spinner: false,
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case FETCH_ADDBASKET_PENDING:
        return {
          done: false,
          error: false,
          spinner: true,
        };
      case FETCH_ADDBASKET_FULFILLED:
        return {
          ...state,
          addBasket: action.payload,
          done: true,
          error: false,
          spinner: false,
        };
      case FETCH_ADDBASKET_REJECTED:
        return {
          ...state,
          error: action.payload,
          done: false,
          spinner: false,
        };
      case RESET_ADDBASKET:
        return {
          initialState,
          done: false,
          error: false,
          spinner: false,
        };
      default:
        return state;
    }
  };
  